import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../api';
import { Status } from "../../common/constants";
import { unassignDeviceUrl } from "../../config";
import { RootState } from "../../store";
import { IUpdateDevicePayload, IUpdateDeviceState } from "../../common/types/devicesTypes";

const initialState: IUpdateDeviceState = {
  status: Status.IDLE,
  error: null,
  msg: null,
  deviceId: null,
  orgId: null,
  displayName: null,
  isActive: false,
};

interface IUpdateDeviceResponse {
  message: string
}



export const unassignDeviceModal = createAsyncThunk("unassignDevice", async (payload: IUpdateDevicePayload, { rejectWithValue }) => {
    try {
      const response = await api.patch(unassignDeviceUrl + `?deviceId=${payload.deviceId}`, payload.body);
      const unassignDeviceResponse: IUpdateDeviceResponse = response.data;
      return unassignDeviceResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const unassignDeviceModalSlice = createSlice({
  name: "unassignDevice",
  initialState,
  reducers: {
    setStatus: (state: IUpdateDeviceState) => {
      state.status = Status.IDLE;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(unassignDeviceModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(unassignDeviceModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS
      })
      .addCase(unassignDeviceModal.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Error occurred while updating';
        state.status = Status.FAILED;
      });
  },
});

export const { setStatus } = unassignDeviceModalSlice.actions;
export const selector = (state: RootState) => state.unassignDeviceApi;

export default unassignDeviceModalSlice.reducer;